import React from "react";
import { FaEye, FaTrashRestoreAlt, FaTrash } from "react-icons/fa";

const AlunoDesativadoCard = ({
  aluno,
  onVisualizar,
  onRestaurar,
  onEliminar,
  disabled = false,
}) => {
  return (
    <div className="aluno-card">
      <button
        onClick={onVisualizar}
        className="btn-ver"
        aria-label={`Ver detalhes de ${aluno.nome_completo}`}
        title="Ver detalhes"
        disabled={disabled}
      >
        <FaEye /> {aluno.codigo_aluno} - {aluno.nome_completo}
      </button>

      <div className="acoes">
        <button
          onClick={() => onRestaurar?.(aluno.id, aluno.nome_completo)}
          className="btn-restaurar"
          title="Restaurar"
          aria-label="Restaurar aluno"
          disabled={disabled}
        >
          <FaTrashRestoreAlt color="green" />
        </button>

        <button
          onClick={() => onEliminar?.(aluno.id, aluno.nome_completo)}
          className="btn-eliminar"
          title="Eliminar definitivamente"
          aria-label="Eliminar aluno"
          disabled={disabled}
        >
          <FaTrash color="red" />
        </button>
      </div>
    </div>
  );
};

export default AlunoDesativadoCard;

